(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kf-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCarousel = (section) => {
      if (section.dataset.kfCarouselInitialised === 'true') return;

      if (section.dataset.kfDesignMode === 'true') {
        section.querySelectorAll('.kf-carousel__view-all-visual a[href]').forEach((link) => {
          link.removeAttribute('href');
          link.removeAttribute('target');
        });
      }

      const track = section.querySelector('[data-kf-carousel-track]');
      const controls = section.querySelector('[data-kf-carousel-controls]');
      const previousButton = section.querySelector('[data-kf-carousel-previous]');
      const nextButton = section.querySelector('[data-kf-carousel-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      section.dataset.kfCarouselInitialised = 'true';

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);
        return parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      };

      const getScrollAmount = () => {
        const firstItem = track.querySelector('.kf-carousel__item');
        return firstItem ? firstItem.getBoundingClientRect().width + getGap() : track.clientWidth;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
    };

    const initialiseAllCarousels = (root = document) => {
      if (root.matches?.('[data-kf-carousel]')) {
        initialiseCarousel(root);
      }
      root.querySelectorAll('[data-kf-carousel]').forEach(initialiseCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAllCarousels());
    } else {
      initialiseAllCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-collection-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-collection-gallery')) {
    class KfCollectionGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.currentLabel = this.querySelector('[data-gallery-current]');
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));

        if (!this.viewport || this.slides.length < 2) return;

        this.dataset.initialized = 'true';
        this.currentIndex = 0;
        this.scrollFrame = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.galleryDot)));
        });

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
        this.updateNavigation();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      getVisibleSlideCount() {
        const firstSlide = this.slides[0];
        if (!firstSlide) return 1;

        const track = this.querySelector('.kf-collection-gallery__track');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const slideWidth = firstSlide.getBoundingClientRect().width;

        return Math.max(1, Math.round(this.viewport.clientWidth / (slideWidth + gap)));
      }

      getMaximumStartIndex() {
        return Math.max(0, this.slides.length - this.getVisibleSlideCount());
      }

      getSlideLeft(slide) {
        return slide.offsetLeft - this.slides[0].offsetLeft;
      }

      getClosestIndex() {
        const maximumIndex = this.getMaximumStartIndex();
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          if (index > maximumIndex) return;

          const distance = Math.abs(this.getSlideLeft(slide) - this.viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      goTo(requestedIndex) {
        const targetIndex = Math.min(Math.max(requestedIndex, 0), this.getMaximumStartIndex());
        const targetSlide = this.slides[targetIndex];
        if (!targetSlide) return;

        this.viewport.scrollTo({
          left: this.getSlideLeft(targetSlide),
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = requestAnimationFrame(() => {
          this.currentIndex = this.getClosestIndex();
          this.updateNavigation();
        });
      }

      handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }
      }

      handleResize() {
        this.currentIndex = Math.min(this.currentIndex, this.getMaximumStartIndex());
        this.viewport.scrollTo({ left: this.getSlideLeft(this.slides[this.currentIndex]), behavior: 'auto' });
        this.updateNavigation();
      }

      updateNavigation() {
        const maximumIndex = this.getMaximumStartIndex();

        if (this.currentLabel) this.currentLabel.textContent = String(this.currentIndex + 1);
        if (this.previousButton) this.previousButton.disabled = this.currentIndex <= 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex >= maximumIndex;

        this.dots.forEach((dot, index) => {
          const isCurrent = index === this.currentIndex;
          dot.classList.toggle('kf-collection-gallery__dot--current', isCurrent);

          if (isCurrent) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('kf-collection-gallery', KfCollectionGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-devonstone-fashion-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-devonstone-fashion')) {
    class KfDevonstoneFashion extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-fashion-viewport]');
        this.slides = [...this.querySelectorAll('[data-fashion-slide]')];
        if (!this.viewport || this.slides.length < 2) return;

        this.previous = this.querySelector('[data-fashion-previous]');
        this.next = this.querySelector('[data-fashion-next]');
        this.current = this.querySelector('[data-fashion-current]');
        this.index = 0;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.onScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        };
        this.onPrevious = () => this.goTo(this.index - 1);
        this.onNext = () => this.goTo(this.index + 1);
        this.onKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-fashion-slide]');
          if (slide) this.goTo(this.slides.indexOf(slide));
        };

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        this.previous?.addEventListener('click', this.onPrevious);
        this.next?.addEventListener('click', this.onNext);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.index, true));
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        if (!this.viewport || this.slides.length < 2) return;
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }

      goTo(index, immediate = false) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const left = this.slides[destination].offsetLeft - this.slides[0].offsetLeft;
        this.viewport.scrollTo({
          left,
          behavior: immediate || this.reducedMotion.matches ? 'auto' : 'smooth',
        });
        this.index = destination;
        this.updateControls();
      }

      update() {
        const offset = this.slides[0].offsetLeft;
        const position = this.viewport.scrollLeft;
        let closest = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const delta = Math.abs(slide.offsetLeft - offset - position);
          if (delta < distance) {
            closest = index;
            distance = delta;
          }
        });

        this.index = closest;
        this.updateControls();
      }

      updateControls() {
        if (this.current) this.current.textContent = String(this.index + 1);
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      }
    }

    customElements.define('kf-devonstone-fashion', KfDevonstoneFashion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-featured-fabric-swatches"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseSwatches = (section) => {
      if (section.dataset.kfSwatchesInitialised === 'true') return;

      const track = section.querySelector('[data-kf-swatch-track]');
      const controls = section.querySelector('[data-kf-slider-controls]');
      const previousButton = section.querySelector('[data-kf-slider-previous]');
      const nextButton = section.querySelector('[data-kf-slider-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      section.dataset.kfSwatchesInitialised = 'true';

      const isSlider = () => {
        return section.classList.contains(
          'kf-featured-swatches--layout-slider'
        );
      };

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);

        return (
          parseFloat(
            trackStyles.columnGap || trackStyles.gap
          ) || 0
        );
      };

      const updateGridColumns = () => {
        if (isSlider()) return;

        const items = track.querySelectorAll(
          '.kf-featured-swatches__item'
        );

        if (!items.length) return;

        const sectionStyles = window.getComputedStyle(section);

        const preferredCardWidth =
          parseFloat(
            sectionStyles.getPropertyValue(
              '--kf-swatch-card-width'
            )
          ) || 320;

        const maximumColumns =
          parseInt(
            sectionStyles.getPropertyValue(
              '--kf-swatch-maximum-columns'
            ),
            10
          ) || 4;

        const gap = getGap();
        const availableWidth = track.clientWidth;

        const fittingColumns = Math.max(
          1,
          Math.floor(
            (availableWidth + gap) /
            (preferredCardWidth + gap)
          )
        );

        const currentColumns = Math.max(
          1,
          Math.min(
            maximumColumns,
            items.length,
            fittingColumns
          )
        );

        track.style.setProperty(
          '--kf-swatch-current-columns',
          currentColumns
        );
      };

      const getScrollAmount = () => {
        const firstCard = track.querySelector(
          '.kf-featured-swatches__item'
        );

        return firstCard
          ? firstCard.getBoundingClientRect().width + getGap()
          : track.clientWidth;
      };

      const updateSliderControls = () => {
        if (!isSlider()) {
          controls.hidden = true;
          return;
        }

        const maximumScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled =
          track.scrollLeft >= maximumScroll - 2;
      };

      const updateLayout = () => {
        updateGridColumns();
        updateSliderControls();
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateSliderControls, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateLayout);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateLayout);
      }

      updateLayout();
    };

    const initialiseAllSwatches = (root = document) => {
      if (root.matches?.('[data-kf-featured-swatches]')) {
        initialiseSwatches(root);
      }

      root
        .querySelectorAll('[data-kf-featured-swatches]')
        .forEach(initialiseSwatches);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAllSwatches();
      });
    } else {
      initialiseAllSwatches();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllSwatches(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-recommendations"] && !Shopify.designMode) return;
  try {
    
  class KfProductRecommendationsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      const track = this.querySelector('[data-kf-recommendations-track]');
      const controls = this.querySelector('[data-kf-recommendations-controls]');
      const previousButton = this.querySelector('[data-kf-recommendations-previous]');
      const nextButton = this.querySelector('[data-kf-recommendations-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);
        return parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      };

      const getScrollAmount = () => {
        const firstItem = track.querySelector('.kf-product-recommendations__item');
        return firstItem ? firstItem.getBoundingClientRect().width + getGap() : track.clientWidth;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener(
        'click',
        () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }),
        { signal }
      );

      nextButton.addEventListener(
        'click',
        () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }),
        { signal }
      );

      track.addEventListener('scroll', updateControls, { passive: true, signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls, { signal });
      }

      requestAnimationFrame(updateControls);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.abortController = null;
      this.resizeObserver = null;
    }
  }

  if (!customElements.get('kf-product-recommendations-carousel')) {
    customElements.define('kf-product-recommendations-carousel', KfProductRecommendationsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
